/** 按角色清除 localStorage 中的登录凭证 */
export const clearAuthStorage = (type) => {
  if (type === "deliverPerson") {
    localStorage.removeItem("deliveryToken");
    localStorage.removeItem("deliverId");
    localStorage.removeItem("deliveryTokenExpiration");
    return;
  }

  if (type === "riderPerson") {
    localStorage.removeItem("riderToken");
    localStorage.removeItem("riderId");
    localStorage.removeItem("riderTokenExpiration");
    return;
  }

  localStorage.removeItem("userToken");
  localStorage.removeItem("userId");
  localStorage.removeItem("tokenExpiration");
};

/** 清除全部角色的登录凭证 */
export const clearAllAuthStorage = () => {
  clearAuthStorage("manage");
  clearAuthStorage("deliverPerson");
  clearAuthStorage("riderPerson");
};

const TOKEN_KEYS = {
  manage: "userToken",
  deliver: "deliveryToken",
  rider: "riderToken",
};

const LOGIN_ROUTES = {
  manage: "login",
  deliver: "deliveryLogin",
  rider: "riderLogin",
};

export const getTokenByAuthRole = (authRole = "manage") =>
  localStorage.getItem(TOKEN_KEYS[authRole] || TOKEN_KEYS.manage);

export const getLoginRouteByAuthRole = (authRole = "manage") =>
  LOGIN_ROUTES[authRole] || LOGIN_ROUTES.manage;
